import { X } from "lucide-react";
import { SHOWREEL_URL, SHOWREEL_WEBM_URL } from "../data/content";

export const ShowreelModal = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div data-testid="showreel-modal" className="fixed inset-0 z-[70] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
      onClick={onClose}>
      <div className="relative w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
        <button data-testid="showreel-close-btn" onClick={onClose}
          className="absolute -top-12 right-0 text-zinc-400 hover:text-amber-500 transition-colors">
          <X className="w-7 h-7" />
        </button>
        <div className="border border-amber-500/40 bg-[#0E0E12]">
          <video data-testid="showreel-video" controls autoPlay playsInline className="w-full aspect-video bg-black">
            <source src={SHOWREEL_URL} type="video/mp4" />
            <source src={SHOWREEL_WEBM_URL} type="video/webm" />
          </video>
        </div>
        <p className="mt-3 font-mono2 text-[11px] tracking-[0.25em] text-zinc-500 uppercase">
          KTH STUDIOS — Kingdom of Theatrical Horizon — Official Showreel
        </p>
      </div>
    </div>
  );
};
